import type { ValidatedProblem } from '../../../interfaces/containers/premises/ValidatedProblem';

export function isTrafficSignalProblem(problem: ValidatedProblem): boolean {
	const trafficSignal = problem?.symptoms?.safety?.trafficSignal;
	return Boolean(trafficSignal?.blinking || trafficSignal?.out);
}
